export default __webpack_public_path__ + "files/f356182e1dc28ee0d6545d9c66b7014a.woff2";